<template>
<div class="col-12">
<div class="grid">
<div class="col-10">
<Dropdown :filter="false"  v-model="thecondition.customattribute_id" :options="customattributes" optionLabel="name" optionValue="id"  class=" p-inputtext-sm w-4" @change="attributeSelected"/>


<template v-if="selected_customattribute">
<template v-if="selected_customattribute.type=='select'">
<Dropdown :filter="false"  v-model="thecondition.numericalval" :options="selected_customattribute.options" optionLabel="name"  optionValue="id" class=" p-inputtext-sm w-4 mr-1 ml-1" @change="valueUpdated" />  değerine eşitse
</template>

<template v-if="selected_customattribute.type=='boolean'">
<Dropdown :filter="false"  v-model="thecondition.numericalval" :options="boolean_options" optionLabel="name"  optionValue="id" class=" p-inputtext-sm w-4 mr-1 ml-1" @change="valueUpdated"/>  değerine eşitse
</template>

<template v-if="selected_customattribute.type=='string'">
<InputText  type="text" v-model="thecondition.textval" class="p-inputtext-sm ml-2 w-4"  @change="valueUpdated"  />  değerine eşitse
</template>

<template v-if="selected_customattribute.type=='number'">
<InputText  type="number" v-model="thecondition.numericalval" class="p-inputtext-sm ml-2 w-2"  @change="valueUpdated"  />  

<Dropdown :filter="false"  v-model="selected_customattribute.logic_operator" :options="number_operators" optionLabel="name" optionValue="id"  class=" p-inputtext-sm w-3" @change="valueUpdated"/>


</template>	
</template>
</div>

<div class="col-2 flex  justify-content-end" v-if="is_editing">
<Button icon="pi pi-check"  class="p-button-outlined p-button-sm p-button-success"   @click="submitCondition"></Button>
<Button icon="pi pi-trash"  class="p-button-outlined p-button-sm p-button-danger ml-2"   @click="deleteCondition"></Button>
</div>

<div class="col-2 flex justify-content-end" v-if="!is_editing">
<Button icon="pi pi-trash"  class="p-button-outlined p-button-sm p-button-danger ml-2"   @click="deleteCondition"></Button>
</div>


</div>


</div>
</template>

<script>
export default {

  name: 'BrandSupplierScorecardCondition',
  props:["condition","customattributes"],
  data () {
    return {
    	thecondition:{
    		id:null,
	        customattribute_id:null,
	        logic_operator:null,
	        numericalval:null,
	        textval:null,
	      },
	    selected_customattribute:null,
      boolean_options:[
      {id:0,name:"Kapalı"},     
      {id:1,name:"Açık"}
      ],
      number_operators:[
      {id:"gt",name:"değerinden büyükse"},
      {id:"st",name:"değerinden küçükse"},
      {id:"eq",name:"değerine eşitse"}
      ],
      is_editing:true,
    }
  },
  mounted()
  {
  	console.log(this.thecondition)
  	let condition = this.sanitizeArray(this.condition)
  	this.thecondition = condition
  	if(condition.customattribute_id)
  	{
  		this.selected_customattribute = this.customattributes.find((item)=>{return item.id == this.thecondition.customattribute_id})
  		this.is_editing = false
  	}

  },
  methods:{
    valueUpdated()
    {
      console.log(this.thecondition)
      if(this.thecondition.id !=="new")
      {
        let formdata = new FormData()
        formdata.append("thecondition",JSON.stringify(this.thecondition))
        this.generalSubmission(formdata,"update_scorecard_condition/"+this.thecondition.id,this.aftersubmitCondition)
      }
    },
  	attributeSelected()
  	{
  		this.selected_customattribute = this.customattributes.find((item)=>{return item.id == this.thecondition.customattribute_id})
  		this.thecondition.logic_operator = null
  		this.thecondition.numericalval = null
  		this.thecondition.textval = null
  		console.log(this.selected_customattribute )
  	},
  	deleteCondition()
  	{
  		if(this.thecondition.id =="new")  		
  		{
  			this.$emit("deleteCondition",this.thecondition.id)
  		}
  		else
  		{
  			let formdata = new FormData()
  			this.generalSubmission(formdata,"delete_scorecard_condition/"+this.thecondition.id,this.aftersubmitCondition)
  		}
  		

  	},
  	editCondition()
  	{

  	},
  	submitCondition()
  	{
  		
  		let formdata = new FormData()
    	formdata.append("thecondition",JSON.stringify(this.thecondition))
    	this.generalSubmission(formdata,"store_scorecard_condition/"+this.$route.params.card_id,this.aftersubmitCondition)

  	},
  	aftersubmitCondition(response)
  	{
  		console.log(response)
  		this.is_editing = false
  		this.$emit("deleteCondition",this.thecondition.id)
  	},

  }
}
</script>

<style lang="css" scoped>
</style>